import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsDialogComponent } from './details-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MapModule } from '@ess-front/angular-components';
import { ReviewingModule } from '../reviewing/reviewing.module';

@NgModule({
  declarations: [DetailsDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,
    MapModule,
    ReviewingModule,
  ],
  exports: [DetailsDialogComponent],
})
export class DetailsDialogModule {}
